import { QueryFactory } from "../../../../Common";
export const QGetOptInTournaments = QueryFactory("GetOptInTournaments");
//# sourceMappingURL=QGetOptInTournaments.js.map